import { TableCellType } from "../table";

import { ToggleSwitch } from "risa-oasis-ui_v2";
import BadgeCell from "./cellTypes/BadgeCell";
import BadgeGroupCell from "./cellTypes/BadgeGroupCell";
import CheckboxCell from "./cellTypes/CheckboxCell";
import EditDeleteIconsCell from "./cellTypes/EditDeleteIconsCell";
import EditIconCell from "./cellTypes/EditIconCell";
import Reset2FACell from "./cellTypes/Reset2FACell";
import StringCell from "./cellTypes/StringCell";

export const TableCell = (props: any) => {
  switch (props.type) {
    case TableCellType.STRING:
      return <StringCell value={props.value} />;
    case TableCellType.BADGE:
      return <BadgeCell value={props.value} />;
    case TableCellType.TOGGLE_SWITCH:
      return (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            width: "100%",
            height: "100%",
          }}
        >
          <ToggleSwitch
            id={props.value.id}
            defaultChecked={props.value.defaultChecked}
            onChangeEmit={props.onChangeEmit}
          />
        </div>
      );
    case TableCellType.EDIT_ICON:
      return (
        <EditIconCell
          value={props.value}
          handleEditIconClick={props.handleEditIconClick}
        />
      );
    case TableCellType.CHECKBOX:
      return (
        <CheckboxCell
          value={props.value}
          toggleCheckboxSelection={props.toggleCheckboxSelection}
        />
      );
    case TableCellType.EDIT_DELETE_ICONS:
      return <EditDeleteIconsCell value={props.value} />;
    case TableCellType.RESET_2FA:
      return <Reset2FACell value={props.value} />;
    case TableCellType.BADGE_GROUP:
      return <BadgeGroupCell value={props.value} />;
    default:
      return <></>;
  }
};
